/************
 * Developed by : Shiva Software Solutions
 * Date : 31-10-2022
 * Descriptions : Route for dahboard page
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const DoctorMasterConfig = [
  //Redirect to dashboard page
  {
    auth: authRole.user,
    routes: [
      {
        path: '/doctors',
        component: React.lazy(() => import('./Doctors')),
      },
    ],
  },
];
